import React, { useState } from "react";
import get from "lodash/get";
import { RadioPageOulu } from "./radio-page-oulu";
import { RadioPagePori } from "./radio-page-pori";
import { RadioPageLapua } from "./radio-page-lapua";
import { RadioPageTurku } from "./radio-page-turku";
import { RadioPageLohja } from "./radio-page-lohja";
import { RadioPageLahti } from "./radio-page-lahti";
import { RADIOT_CLICKED, RADIOT_HELSINKI } from "../../store/actions";
import { RadioPageTornio } from "./radio-page-tornio";
import { RadioPageKajani } from "./radio-page-kajani";
import { ResponsiveImage } from "@quintype/components";
import { useDispatch, useSelector } from "react-redux";
import { RadioPageHelsinki } from "./radio-page-helsinki";
import { RadioPageRovaniemi } from "./radio-page-rovaniemi";
import { RadioPageKruunupyy } from "./radio-page-kruunupyy";
import { RadioPageYleisohjelma } from "./radio-page-yleisohjelma";
import { RadioPageKristiinankaupunki } from "./radio-page-kristiinankaupunki";
import { Link } from "@quintype/components";
import { useEffect } from "react";

const RadioPage = () => {
  const defaultSettings = useSelector((state) => get(state, ["qt", "config"]));

  const radioStations = [
    {
      station: "yleisohjelma",
      displayName: "Dei Valtakunnallinen",
      component: RadioPageYleisohjelma,
      heroImg: get(defaultSettings, ["publisher-attributes", "valtakunnallinenImageKey"], ""),
      destUrl: "/radiot-valtakunnallinen"
    },
    {
      station: "helsinki",
      displayName: "Dei Pääkaupunkiseutu",
      component: RadioPageHelsinki,
      heroImg: get(defaultSettings, ["publisher-attributes", "helsinkiImageKey"], ""),
      destUrl: "/radiot-helsinki"
    },
    {
      station: "lohja",
      displayName: "Dei Lohja",
      component: RadioPageLohja,
      heroImg: get(defaultSettings, ["publisher-attributes", "lohjaImageKey"], ""),
      destUrl: "/radiot-lohja"
    },
    {
      station: "oulu",
      displayName: "Radio Dei Oulu",
      component: RadioPageOulu,
      heroImg: get(defaultSettings, ["publisher-attributes", "ouluImageKey"], ""),
      destUrl: "/radiot-oulu"
    },
    {
      station: "rovaniemi",
      displayName: "Radio Dei Rovaniemi",
      component: RadioPageRovaniemi,
      heroImg: get(defaultSettings, ["publisher-attributes", "rovaniemiImageKey"], ""),
      destUrl: "/radiot-rovaniemi"
    },
    {
      station: "tornio",
      displayName: "Radio Dei Pohjanmaa",
      component: RadioPageTornio,
      heroImg: get(defaultSettings, ["publisher-attributes", "pohjanmaaImageKey"], ""),
      destUrl: "/radiot-pohjanma"
    },
    {
      station: "turku",
      displayName: "Radio Dei Turku",
      component: RadioPageTurku,
      heroImg: get(defaultSettings, ["publisher-attributes", "turkuImageKey"], ""),
      destUrl: "/radiot-turku"
    },
    {
      station: "kajaani",
      displayName: "Dei Kajaani",
      component: RadioPageKajani,
      heroImg: get(defaultSettings, ["publisher-attributes", "kajaaniImageKey"], ""),
      destUrl: "/radiot-kaajani"
    },
  ];

  const [selectedStation, setSelectedStation] = useState("");
  const SelectedComponent = radioStations.find((station) => station.station === selectedStation)?.component;
  const dispatch = useDispatch();
  const getState = useSelector((state) => state);
  const isRadiotClicked = get(getState, ["isRadiotClicked"], false);

  const style = `
    .main-logos-grid-container {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      gap: 20px;
      max-width: 1200px;
      margin: auto;
      padding: 25px 15px 0 15px;
    }
    .main-logos-grid-container figure {
      aspect-ratio: 16 / 9;
      width: 100%;
      overflow: hidden;
      margin: 0;
      border: 1px solid #ccc;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    }
    .main-logos-grid-container figure img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 10px;
      box-sizing: border-box;
    }
    @media (min-width: 1024px) {
      .main-logos-grid-container {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    @media (max-width: 600px) {
      .main-logos-grid-container {
        grid-template-columns: repeat(2, 1fr);
      }
    }
    .calendarWrapper {
      margin: 30px auto;
      width: 1172px;
    }

    @media (max-width: 1172px) {
      .calendarWrapper {
        width: 100%;
      }
    }
    .radio-page-title-row {
      display: flex;
      justify-content: space-between;
      padding: 150px 25px 0 25px;
      color: #FFF;
      max-width: 1200px;
      margin: auto;
      align-items: center;
    }
    .radio-page-title {
      font-size: 24px;
      font-weight: 600;
      color: #ac3040;
      font-family: "Montserrat", sans-serif;
    }
    .radio-page-btns-wrapper {
      display: flex;
      gap: 10px;
    }
    .radio-page-ohjelmatiedot-btn {
      border-radius: 10px;
      background-color: #ac3040;
      font-weight: 600;
      font-size: 20px;
      padding: 1rem;
    }
    .radio-page-soittolista-btn {
      border-radius: 10px;
      background-color: #333333;
      font-weight: 600;
      font-size: 20px;
      padding: 1rem;
    }
    .radio-page-toivomusiikkia-btn {
      border-radius: 10px;
      background-color: #333333;
      font-weight: 600;
      font-size: 20px;
      padding: 1rem;
    }
    .radio-page-ohjelmatiedot-btn-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      justify-content: center;
    }
    .radio-page-soittolista-btn-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      justify-content: center;
    }
    .radio-page-toivomusiikkia-btn-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      justify-content: center;
    }
    .radio-page-ohjelmatiedot-btn-wrapper p, .radio-page-soittolista-btn-wrapper p, .radio-page-toivomusiikkia-btn-wrapper p {
      margin: 5px 0;
      font-size: 16px;
      font-weight: 600;
      font-family: "Montserrat", sans-serif;
    }
    .calendar-img-icon, .soittolista-img-icon {
      width: 25px;
      height: 25px;
    }
    .toivomusiikkia-img-icon{width: 30px;height: 30px;margin-left:-5px;margin-top:-5px}
    @media only screen and (max-width: 767px) {
      .radio-page-ohjelmatiedot-btn p, .radio-page-soittolista-btn p, .radio-page-toivomusiikkia-btn p {
        display: none;
      }
      .radio-page-soittolista-btn, .radio-page-toivomusiikkia-btn {
        background-color: #ac3040;
      }
      .radio-page-toivomusiikkia-btn {padding-top: 5px;padding-left: 5px;}
      .toivomusiikkia-img-icon{margin-left:0px;margin-top:0px}
    }
    #ohjelmatiedot-section {
      scroll-margin-top: 50px;
    }
    @media only screen and (max-width: 1024px) {
      #ohjelmatiedot-section {
        scroll-margin-top: 60px;
      }
    }
  `;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
    <style dangerouslySetInnerHTML={{ __html: style }} />
    <div className="radio-page-title-row">
        <h1 className="radio-page-title">Radiokanavat</h1>
        <div className="radio-page-btns-wrapper">
          <a className="radio-page-toivomusiikkia-btn" href="https://www.kry.fi/ojelmat/toivo-musiikkia/" target="_blank">
            <div className="radio-page-toivomusiikkia-btn-wrapper">
              <img src="/icons/radio-toivomusiikkia-logo.svg" className="toivomusiikkia-img-icon" />
              <p>Toivo musiikkia</p>
            </div>
          </a>
          <a className="radio-page-soittolista-btn" href="https://www.kry.fi/ojelmat/soittolista/" target="_blank">
            <div className="radio-page-soittolista-btn-wrapper">
              <img src="/icons/radio-soittolista-logo.svg" className="soittolista-img-icon" />
              <p>Soittolista</p>
            </div>
          </a>
          <a className="radio-page-ohjelmatiedot-btn" href="/radiodei-ohjelmakartta" target="_blank">
            <div className="radio-page-ohjelmatiedot-btn-wrapper">
              <img src="/icons/radio-calendar-logo.svg" className="calendar-img-icon" />
              <p>Ohjelmakartta</p>
            </div>
          </a>
        </div>
    </div>
    <div>
      {!selectedStation || isRadiotClicked ? (
        <div className="main-logos-grid-container">

            {radioStations.map((station, index) => (
              <Link href={station.destUrl}>
                <figure
                  key={index}
                  style={{ cursor: "pointer" }}
                >
                    <ResponsiveImage
                      aspectRatio={[16, 9]}
                      defaultWidth={480}
                      widths={[250, 480, 640]}
                      slug={station.heroImg}
                      alt={station.displayName}
                    />
                  <figcaption></figcaption>
                </figure>
              </Link>
            ))}

        </div>
      ) : (
        SelectedComponent && !isRadiotClicked && <SelectedComponent />
      )}
    </div>

    <div className="calendarWrapper" id="ohjelmatiedot-section">
      <div
        className="elfsight-app-bdedc657-9501-4797-958c-de2cef2a629a"
        data-elfsight-app-lazy
        style={{ zIndex: 0, position: 'relative' }}
      ></div>
    </div>
    </>
  );
};

export { RadioPage };
